import { makeAutoObservable } from 'mobx';

class TariffsStore {
  activePriceTab = 0;

  constructor() {
    makeAutoObservable(this);
  }

  setActivePriceTab = (tab: number) => {
    this.activePriceTab = tab;
  };
}

export const tariffsStore = new TariffsStore();
